/* =============================================
   SK THEME — JavaScript
   Custom cursor, dropdowns, Shopify AJAX cart,
   Currency conversion, Language translation
   ============================================= */

(function() {
  'use strict';

  /* =============================================
     STATE PERSISTENCE (localStorage)
     ============================================= */
  var skState = {
    currency: localStorage.getItem('sk-currency') || 'USD',
    language: localStorage.getItem('sk-language') || 'EN'
  };

  function skSet(key, val) {
    skState[key] = val;
    try { localStorage.setItem('sk-' + key, val); } catch(e) {}
  }

  function skGet(key) {
    return skState[key] || null;
  }

  /* =============================================
     CURRENCY CONVERSION
     ============================================= */
  var RATES = { USD: 1, EUR: 0.92, GBP: 0.79, JPY: 149.50, CAD: 1.36 };
  var SYMBOLS = { USD: '$', EUR: '\u20ac', GBP: '\u00a3', JPY: '\u00a5', CAD: 'CA$' };

  function formatPrice(usdCents, currency) {
    if (!currency) currency = skGet('currency') || 'USD';
    var rate = RATES[currency] || 1;
    var sym = SYMBOLS[currency] || '$';
    var val = Math.round(usdCents * rate / 100);
    return sym + val.toLocaleString('en');
  }

  function convertAllPrices() {
    var currency = skGet('currency') || 'USD';
    /* Convert elements with data-usd attribute (product pages) */
    document.querySelectorAll('[data-usd]').forEach(function(el) {
      var usdCents = parseInt(el.getAttribute('data-usd'), 10);
      if (!isNaN(usdCents)) {
        el.textContent = formatPrice(usdCents, currency);
      }
    });
    /* Convert Shopify money elements — store original cents on first pass */
    document.querySelectorAll('[data-shopify-price]').forEach(function(el) {
      var usdCents = parseInt(el.getAttribute('data-shopify-price'), 10);
      if (!isNaN(usdCents)) {
        el.textContent = formatPrice(usdCents, currency);
      }
    });
  }

  function applyCurrency() {
    var currency = skGet('currency') || 'USD';
    /* Update nav icon text */
    var navIcon = document.querySelector('.nav-icon[data-panel="currency-panel"] .icon-text');
    if (navIcon) navIcon.textContent = currency;
    /* Update active state in panel */
    document.querySelectorAll('#currency-panel .option-item').forEach(function(item) {
      if (item.getAttribute('data-value') === currency) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    convertAllPrices();
  }

  function bindCurrency() {
    document.querySelectorAll('#currency-panel .option-item').forEach(function(item) {
      item.addEventListener('click', function() {
        var val = this.getAttribute('data-value');
        skSet('currency', val);
        applyCurrency();
        refreshCart();
        closeAllPanels();
      });
    });
  }

  /* =============================================
     LANGUAGE / TRANSLATION
     ============================================= */
  var TRANSLATIONS = {
    EN: {},
    FR: {
      'Search...': 'Rechercher...',
      'Your cart is empty': 'Votre panier est vide',
      'Checkout': 'Commander',
      'Add to Cart': 'Ajouter au panier',
      'Added': 'Ajout\u00e9',
      'Sold Out': '\u00c9puis\u00e9',
      'Size': 'Taille',
      'Coming Soon': 'BIENT\u00d4T DISPONIBLE',
      'Brands': 'Marques'
    },
    DE: {
      'Search...': 'Suchen...',
      'Your cart is empty': 'Ihr Warenkorb ist leer',
      'Checkout': 'Zur Kasse',
      'Add to Cart': 'In den Warenkorb',
      'Added': 'Hinzugef\u00fcgt',
      'Sold Out': 'Ausverkauft',
      'Size': 'Gr\u00f6\u00dfe',
      'Coming Soon': 'DEMN\u00c4CHST',
      'Brands': 'Marken'
    },
    JP: {
      'Search...': '\u691c\u7d22...',
      'Your cart is empty': '\u30ab\u30fc\u30c8\u306f\u7a7a\u3067\u3059',
      'Checkout': '\u8cfc\u5165\u624b\u7d9a\u304d',
      'Add to Cart': '\u30ab\u30fc\u30c8\u306b\u8ffd\u52a0',
      'Added': '\u8ffd\u52a0\u6e08\u307f',
      'Sold Out': '\u58f2\u308a\u5207\u308c',
      'Size': '\u30b5\u30a4\u30ba',
      'Coming Soon': '\u8fd1\u65e5\u767a\u58f2',
      'Brands': '\u30d6\u30e9\u30f3\u30c9'
    },
    ES: {
      'Search...': 'Buscar...',
      'Your cart is empty': 'Tu carrito est\u00e1 vac\u00edo',
      'Checkout': 'Pagar',
      'Add to Cart': 'A\u00f1adir al carrito',
      'Added': 'A\u00f1adido',
      'Sold Out': 'Agotado',
      'Size': 'Talla',
      'Coming Soon': 'PR\u00d3XIMAMENTE',
      'Brands': 'Marcas'
    }
  };

  function skTranslate(key) {
    var lang = skGet('language') || 'EN';
    if (lang === 'EN') return key;
    var dict = TRANSLATIONS[lang];
    if (dict && dict[key]) return dict[key];
    return key;
  }

  function translatePage() {
    document.querySelectorAll('[data-i18n]').forEach(function(el) {
      var key = el.getAttribute('data-i18n');
      var translated = skTranslate(key);
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        el.placeholder = translated;
      } else {
        el.textContent = translated;
      }
    });
  }

  function applyLanguage() {
    var lang = skGet('language') || 'EN';
    /* Update active state in panel */
    document.querySelectorAll('#language-panel .option-item').forEach(function(item) {
      if (item.getAttribute('data-value') === lang) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    translatePage();
  }

  function bindLanguage() {
    document.querySelectorAll('#language-panel .option-item').forEach(function(item) {
      item.addEventListener('click', function() {
        var val = this.getAttribute('data-value');
        skSet('language', val);
        applyLanguage();
        refreshCart();
        closeAllPanels();
      });
    });
  }

  /* =============================================
     CUSTOM CURSOR
     ============================================= */
  var cursorEl = document.querySelector('.cursor');
  if (cursorEl) {
    document.addEventListener('mousemove', function(e) {
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top = e.clientY + 'px';
    });

    var hoverClass = document.querySelector('.sk-logo') ? 'hover-sk' : 'hover-active';

    function bindCursorHover() {
      var selectors = 'a, button, .product-card, .option-item, .product-image, .gallery, .gallery-thumb, .gallery-nav, .nav-icon, .cart-item-link, .cart-item-remove, .footer-links a, .sk-logo, .brand-item a, .size-btn, .lightbox-close, .lightbox-nav, .gallery-img, .nav-brands-label, .nav-brands-link';
      document.querySelectorAll(selectors).forEach(function(el) {
        el.addEventListener('mouseenter', function() { cursorEl.classList.add(hoverClass); });
        el.addEventListener('mouseleave', function() { cursorEl.classList.remove(hoverClass); });
      });
    }

    bindCursorHover();
    window.bindCursorHover = bindCursorHover;
  }

  /* =============================================
     DROPDOWN PANELS
     ============================================= */
  var overlay = document.querySelector('.dropdown-overlay');
  var panels = document.querySelectorAll('.dropdown-panel');
  var navIcons = document.querySelectorAll('.nav-icon[data-panel]');

  function closeAllPanels() {
    panels.forEach(function(p) { p.classList.remove('open'); });
    if (overlay) overlay.classList.remove('open');
    var si = document.querySelector('.search-input');
    if (si) si.value = '';
    var sr = document.querySelector('.search-results');
    if (sr) sr.innerHTML = '';
  }
  window.closeAllPanels = closeAllPanels;

  navIcons.forEach(function(icon) {
    icon.addEventListener('click', function(e) {
      e.preventDefault();
      var panel = document.getElementById(icon.dataset.panel);
      var isOpen = panel.classList.contains('open');
      closeAllPanels();
      if (!isOpen) {
        panel.classList.add('open');
        if (overlay) overlay.classList.add('open');
        var si = panel.querySelector('.search-input');
        if (si) si.focus();
      }
    });
  });

  if (overlay) overlay.addEventListener('click', closeAllPanels);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeAllPanels(); });

  /* Close dropdown panels on scroll */
  window.addEventListener('scroll', function() {
    var anyOpen = document.querySelector('.dropdown-panel.open');
    if (anyOpen) closeAllPanels();
    var brandsBar = document.querySelector('.nav-brands-bar.open');
    if (brandsBar) brandsBar.classList.remove('open');
  }, { passive: true });

  /* =============================================
     BRANDS BAR (click to toggle horizontal bar)
     ============================================= */
  var brandsLabel = document.querySelector('.nav-brands-label');
  var brandsBar = document.querySelector('.nav-brands-bar');
  if (brandsLabel && brandsBar) {
    brandsLabel.addEventListener('click', function(e) {
      e.stopPropagation();
      brandsBar.classList.toggle('open');
      closeAllPanels();
    });

    document.addEventListener('click', function(e) {
      if (brandsBar.classList.contains('open') && !brandsBar.contains(e.target) && e.target !== brandsLabel) {
        brandsBar.classList.remove('open');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && brandsBar.classList.contains('open')) {
        brandsBar.classList.remove('open');
      }
    });

    /* Add tapped class on click for visual feedback */
    document.querySelectorAll('.nav-brands-link').forEach(function(link) {
      link.addEventListener('click', function() { link.classList.add('tapped'); });
    });
  }

  /* Same for homepage brand links — delay navigation on touch so magnify effect is visible */
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  document.querySelectorAll('.brand-item a').forEach(function(link) {
    link.addEventListener('click', function(e) {
      link.classList.add('tapped');
      if (isTouchDevice) {
        e.preventDefault();
        var href = link.getAttribute('href');
        setTimeout(function() { window.location.href = href; }, 250);
      }
    });
  });

  /* Clear tapped state when returning to page (back/forward navigation) */
  window.addEventListener('pageshow', function() {
    document.querySelectorAll('.brand-item a.tapped, .nav-brands-link.tapped').forEach(function(el) {
      el.classList.remove('tapped');
    });
  });

  /* =============================================
     SHOPIFY AJAX CART
     ============================================= */
  var cachedCart = null;

  function refreshCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cachedCart = cart;
        var badge = document.querySelector('.cart-badge');
        if (badge) badge.textContent = cart.item_count;
        renderCartDropdown(cart);
      })
      .catch(function() {});
  }

  function renderCartDropdown(cart) {
    var cartItemsEl = document.querySelector('.cart-items');
    var cartEmpty = document.querySelector('.cart-empty');
    var cartFooter = document.querySelector('.cart-footer');
    var cartBadge = document.querySelector('.cart-badge');
    var currency = skGet('currency') || 'USD';

    if (cartBadge) cartBadge.textContent = cart.item_count;
    if (!cartItemsEl) return;
    cartItemsEl.innerHTML = '';

    if (cartEmpty) cartEmpty.textContent = skTranslate('Your cart is empty');
    var checkoutBtnEl = document.querySelector('.cart-checkout');
    if (checkoutBtnEl) checkoutBtnEl.textContent = skTranslate('Checkout');

    if (cart.item_count === 0) {
      if (cartEmpty) cartEmpty.style.display = '';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'flex';

    var totalCents = 0;
    cart.items.forEach(function(item, idx) {
      var usdCents = item.final_line_price; /* Shopify returns cents in store currency (USD) */
      totalCents += usdCents;
      var displayPrice = formatPrice(usdCents, currency);

      var div = document.createElement('div');
      div.className = 'cart-item';
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_100x$1') : '';
      var productUrl = item.url ? item.url.split('?')[0] : '/products/' + item.handle;
      div.innerHTML =
        '<a href="' + productUrl + '" class="cart-item-link">' +
          '<div class="cart-item-img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" />' : '') + '</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + item.product_title + '</div>' +
            '<div class="cart-item-size">' + skTranslate('Size') + ': ' + item.variant_title + '</div>' +
            '<div class="cart-item-price">' + displayPrice + '</div>' +
          '</div>' +
        '</a>' +
        '<button class="cart-item-remove" data-line="' + (idx + 1) + '">&times;</button>';
      cartItemsEl.appendChild(div);
    });

    var cartTotal = document.querySelector('.cart-total');
    if (cartTotal) cartTotal.textContent = formatPrice(totalCents, currency);

    document.querySelectorAll('.cart-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var line = parseInt(this.getAttribute('data-line'), 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cachedCart = cart;
          renderCartDropdown(cart);
        })
        .catch(function() {});
      });
    });

    if (window.bindCursorHover) window.bindCursorHover();
  }

  /* =============================================
     ADD TO CART
     ============================================= */

  function markAdded(btn) {
    btn.textContent = skTranslate('Added');
    btn.classList.add('cart-added');
    btn.disabled = true;
  }

  /* Collection page */
  document.querySelectorAll('.product-card .add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('cart-added')) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      addToCart(variantId, btn);
    });
    /* On mobile, block hover image swap when add-to-cart is tapped */
    var card = btn.closest('.product-card');
    if (card) {
      btn.addEventListener('touchstart', function() {
        card.classList.add('no-hover-img');
        setTimeout(function() {
          document.addEventListener('touchstart', function rm() {
            card.classList.remove('no-hover-img');
            document.removeEventListener('touchstart', rm, true);
          }, true);
        }, 50);
      }, {passive: true});
    }
  });

  /* Product detail page */
  var productAddBtn = document.querySelector('.product-detail .add-to-cart');
  if (productAddBtn) {
    productAddBtn.addEventListener('click', function() {
      if (productAddBtn.classList.contains('cart-added')) return;
      var activeSize = document.querySelector('.size-btn.active');
      if (!activeSize) return;
      var variantId = activeSize.getAttribute('data-variant-id');
      if (!variantId) return;
      addToCart(variantId, productAddBtn);
    });
  }

  function addToCart(variantId, btn) {
    if (btn.classList.contains('cart-added')) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      markAdded(btn);
      refreshCart();
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.textContent = skTranslate('Add to Cart');
      }, 1500);
    });
  }

  /* Check if current product variant is already in cart on page load */
  function checkAlreadyInCart() {
    var addBtn = document.querySelector('.product-detail .add-to-cart');
    if (!addBtn) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var activeSize = document.querySelector('.size-btn.active');
        if (!activeSize) return;
        var currentVariant = parseInt(activeSize.getAttribute('data-variant-id'), 10);
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === currentVariant) {
            markAdded(addBtn);
            return;
          }
        }
      })
      .catch(function() {});
  }

  /* =============================================
     SIZE BUTTONS
     ============================================= */
  document.querySelectorAll('.size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      /* Update dynamic checkout form variant */
      var dynamicInput = document.getElementById('dynamic-variant-id');
      if (dynamicInput) dynamicInput.value = btn.getAttribute('data-variant-id');
      /* Re-check if this variant is already in cart */
      var addBtn = document.querySelector('.product-detail .add-to-cart');
      if (!addBtn) return;
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (cachedCart && cachedCart.items) {
        var inCart = false;
        for (var i = 0; i < cachedCart.items.length; i++) {
          if (cachedCart.items[i].variant_id === variantId) { inCart = true; break; }
        }
        if (inCart) {
          markAdded(addBtn);
        } else {
          addBtn.textContent = skTranslate('Add to Cart');
          addBtn.classList.remove('cart-added');
          addBtn.disabled = false;
        }
      }
    });
  });

  /* =============================================
     CHECKOUT BUTTON
     ============================================= */
  var checkoutBtn = document.querySelector('.cart-checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      window.location.href = '/checkout';
    });
  }

  /* =============================================
     PREDICTIVE SEARCH (Shopify)
     ============================================= */
  function bindSearch() {
    var input = document.querySelector('.search-input');
    var results = document.querySelector('.search-results');
    if (!input || !results) return;
    var activeIdx = -1;
    var currentItems = [];
    var debounceTimer = null;

    function doSearch() {
      var q = input.value.trim();
      results.innerHTML = '';
      activeIdx = -1;
      currentItems = [];
      if (!q) return;

      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          results.innerHTML = '';
          currentItems = [];
          var currency = skGet('currency') || 'USD';

          /* Collection (brand) results */
          if (data.resources && data.resources.results && data.resources.results.collections) {
            data.resources.results.collections.forEach(function(col) {
              var a = document.createElement('a');
              a.className = 'search-result-brand';
              a.href = col.url;
              a.innerHTML = '<div><div class="search-result-brand-name">' + col.title + '</div><div class="search-result-brand-label">Brand</div></div>';
              results.appendChild(a);
              currentItems.push(a);
            });
          }

          /* Product results */
          if (data.resources && data.resources.results && data.resources.results.products) {
            if (currentItems.length > 0) {
              var divider = document.createElement('div');
              divider.className = 'search-divider';
              results.appendChild(divider);
            }
            data.resources.results.products.forEach(function(product) {
              var a = document.createElement('a');
              a.className = 'search-result-item';
              a.href = product.url;
              var imgHtml = product.image ? '<img class="search-result-img" src="' + product.image.replace(/(\.[^.]+)$/, '_100x$1') + '" alt="' + product.title + '" />' : '<div class="search-result-img"></div>';
              /* Convert price from Shopify (string like "$1,250") to display currency */
              var priceText = product.price;
              var meta = product.vendor + ' \u00b7 ' + priceText;
              a.innerHTML = imgHtml + '<div class="search-result-info"><div class="search-result-name">' + product.title + '</div><div class="search-result-meta">' + meta + '</div></div>';
              results.appendChild(a);
              currentItems.push(a);
            });
          }

          if (window.bindCursorHover) window.bindCursorHover();
        })
        .catch(function() {});
    }

    function setActive(idx) {
      currentItems.forEach(function(item) { item.classList.remove('active'); });
      activeIdx = idx;
      if (idx >= 0 && idx < currentItems.length) {
        currentItems[idx].classList.add('active');
        currentItems[idx].scrollIntoView({ block: 'nearest' });
      }
    }

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doSearch, 200);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(activeIdx < currentItems.length - 1 ? activeIdx + 1 : 0);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIdx > 0 ? activeIdx - 1 : currentItems.length - 1);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        var target = activeIdx >= 0 ? currentItems[activeIdx] : currentItems[0];
        if (target) window.location.href = target.getAttribute('href');
      }
    });
  }

  /* =============================================
     IMAGE GALLERY (thumbnails, arrows, wheel, drag, touch, keyboard, auto-cycle)
     ============================================= */
  function initGallery() {
    var galleryImgs = document.querySelectorAll('.gallery-img');
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var galleryMain = document.querySelector('.gallery-main');
    if (!galleryMain || galleryImgs.length === 0) return;

    var currentIdx = 0;
    var dragStartX = 0;

    /* Single-image: skip slideshow but still init lightbox */
    if (galleryImgs.length < 2) {
      var lightbox = document.getElementById('lightbox');
      if (lightbox) {
        var lbImgs = lightbox.querySelectorAll('.lightbox-img');
        var lbWrap = lightbox.querySelector('.lightbox-img-wrap');
        var isZoomed = false;
        var ZOOM_SCALE = 2.8;

        function lbOpen() {
          if (lbImgs.length) lbImgs[0].classList.add('active');
          lightbox.classList.add('open');
          document.body.style.overflow = 'hidden';
        }

        function exitZoom() {
          isZoomed = false;
          lightbox.classList.remove('zoomed');
          if (lbImgs[0]) {
            lbImgs[0].style.transform = '';
            lbImgs[0].style.transformOrigin = '';
          }
        }

        function lbClose() {
          exitZoom();
          lightbox.classList.remove('open');
          document.body.style.overflow = '';
        }

        galleryImgs[0].addEventListener('click', function() { lbOpen(); });

        /* Zoom pan helper — origin relative to wrap element */
        function zoomPan(img, mx, my) {
          var r = lbWrap.getBoundingClientRect();
          var ox = ((mx - r.left) / r.width) * 100;
          var oy = ((my - r.top) / r.height) * 100;
          img.style.transformOrigin = ox + '% ' + oy + '%';
        }

        /* Click image to toggle zoom (desktop only) */
        if (lbWrap) {
          lbWrap.addEventListener('click', function(e) {
            e.stopPropagation();
            if (window.innerWidth <= 768) return;
            if (isZoomed) {
              exitZoom();
            } else {
              isZoomed = true;
              lightbox.classList.add('zoomed');
              var img = lbImgs[0];
              if (img) {
                img.style.transform = 'scale(' + ZOOM_SCALE + ')';
                zoomPan(img, e.clientX, e.clientY);
              }
            }
          });

          lbWrap.addEventListener('mousemove', function(e) {
            if (!isZoomed) return;
            var img = lbImgs[0];
            if (!img) return;
            zoomPan(img, e.clientX, e.clientY);
          });
        }

        var lbCloseBtn = lightbox.querySelector('.lightbox-close');
        if (lbCloseBtn) lbCloseBtn.addEventListener('click', lbClose);

        lightbox.addEventListener('click', function(e) {
          if (e.target === lightbox) lbClose();
        });

        document.addEventListener('keydown', function(e) {
          if (!lightbox.classList.contains('open')) return;
          if (e.key === 'Escape') {
            if (isZoomed) { exitZoom(); } else { lbClose(); }
            e.preventDefault();
          }
        });

        if (window.bindCursorHover) window.bindCursorHover();
      }
      return;
    }

    function goToSlide(idx) {
      currentIdx = ((idx % galleryImgs.length) + galleryImgs.length) % galleryImgs.length;
      for (var i = 0; i < galleryImgs.length; i++) { galleryImgs[i].classList.remove('active'); }
      for (var j = 0; j < thumbs.length; j++) { thumbs[j].classList.remove('active'); }
      galleryImgs[currentIdx].classList.add('active');
      if (thumbs[currentIdx]) {
        thumbs[currentIdx].classList.add('active');
        thumbs[currentIdx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    /* Thumbnail clicks */
    for (var t = 0; t < thumbs.length; t++) {
      (function(thumb) {
        thumb.addEventListener('click', function() {
          clearInterval(autoplay);
          goToSlide(parseInt(thumb.getAttribute('data-index'), 10));
        });
      })(thumbs[t]);
    }

    /* Auto-cycle every 4 seconds */
    var autoplay = setInterval(function() { goToSlide(currentIdx + 1); }, 4000);

    /* Arrow button clicks */
    var prevBtn = document.querySelector('.gallery-nav.prev');
    var nextBtn = document.querySelector('.gallery-nav.next');
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation(); clearInterval(autoplay); goToSlide(currentIdx - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation(); clearInterval(autoplay); goToSlide(currentIdx + 1);
      });
    }

    /* Keyboard arrow keys */
    document.addEventListener('keydown', function(e) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.key === 'ArrowLeft') { clearInterval(autoplay); goToSlide(currentIdx - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { clearInterval(autoplay); goToSlide(currentIdx + 1); e.preventDefault(); }
    });

    /* Scroll wheel on gallery — mobile only */
    galleryMain.addEventListener('wheel', function(e) {
      if (window.innerWidth > 768) return;
      e.preventDefault();
      clearInterval(autoplay);
      if (e.deltaY > 0 || e.deltaX > 0) goToSlide(currentIdx + 1);
      else goToSlide(currentIdx - 1);
    }, { passive: false });

    /* Drag/swipe on gallery */
    var isDragging = false;

    galleryMain.addEventListener('mousedown', function(e) {
      isDragging = true;
      dragStartX = e.clientX;
      galleryMain.classList.add('dragging');
      clearInterval(autoplay);
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
    });

    document.addEventListener('mouseup', function(e) {
      if (!isDragging) return;
      isDragging = false;
      galleryMain.classList.remove('dragging');
      var diff = e.clientX - dragStartX;
      if (Math.abs(diff) > 40) {
        if (diff < 0) goToSlide(currentIdx + 1);
        else goToSlide(currentIdx - 1);
      }
    });

    /* Touch support for mobile */
    var touchStartX = 0;
    var touchIsMulti = false;
    var touchMultiEnd = 0;
    function isPageZoomed() { return window.visualViewport && window.visualViewport.scale > 1.05; }
    galleryMain.addEventListener('touchstart', function(e) {
      touchIsMulti = e.touches.length > 1;
      touchStartX = e.touches[0].clientX;
      clearInterval(autoplay);
    }, { passive: true });

    galleryMain.addEventListener('touchmove', function(e) {
      if (e.touches.length > 1) touchIsMulti = true;
    }, { passive: true });

    galleryMain.addEventListener('touchend', function(e) {
      if (touchIsMulti) { touchIsMulti = false; touchMultiEnd = Date.now(); return; }
      if (Date.now() - touchMultiEnd < 400) return;
      if (isPageZoomed()) return;
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 40) {
        if (diff < 0) goToSlide(currentIdx + 1);
        else goToSlide(currentIdx - 1);
      }
    }, { passive: true });

    /* =============================================
       LIGHTBOX / FULLSCREEN IMAGE VIEWER
       ============================================= */
    var lightbox = document.getElementById('lightbox');
    if (lightbox) {
      var lbImgs = lightbox.querySelectorAll('.lightbox-img');
      var lbCounter = lightbox.querySelector('.lightbox-current');
      var lbWrap = lightbox.querySelector('.lightbox-img-wrap');
      var lbIdx = 0;
      var isZoomed = false;
      var ZOOM_SCALE = 2.8;

      function exitZoom() {
        isZoomed = false;
        lightbox.classList.remove('zoomed');
        for (var i = 0; i < lbImgs.length; i++) {
          lbImgs[i].style.transform = '';
          lbImgs[i].style.transformOrigin = '';
        }
      }

      function lbGoTo(idx) {
        if (isZoomed) exitZoom();
        lbIdx = ((idx % lbImgs.length) + lbImgs.length) % lbImgs.length;
        for (var i = 0; i < lbImgs.length; i++) { lbImgs[i].classList.remove('active'); }
        lbImgs[lbIdx].classList.add('active');
        if (lbCounter) lbCounter.textContent = lbIdx + 1;
      }

      function lbOpen(idx) {
        lbGoTo(idx);
        lightbox.classList.add('open');
        document.body.style.overflow = 'hidden';
      }

      function lbClose() {
        exitZoom();
        lightbox.classList.remove('open');
        document.body.style.overflow = '';
      }

      /* Click gallery image to open lightbox */
      var clickStartX = 0;
      galleryMain.addEventListener('mousedown', function(e) { clickStartX = e.clientX; });
      galleryMain.addEventListener('click', function(e) {
        if (Math.abs(e.clientX - clickStartX) > 10) return;
        if (e.target.classList.contains('gallery-nav')) return;
        lbOpen(currentIdx);
      });

      /* Zoom pan helper — origin relative to wrap element */
      function zoomPan(img, mx, my) {
        var r = lbWrap.getBoundingClientRect();
        var ox = ((mx - r.left) / r.width) * 100;
        var oy = ((my - r.top) / r.height) * 100;
        img.style.transformOrigin = ox + '% ' + oy + '%';
      }

      /* Click lightbox image to toggle zoom (desktop only) */
      if (lbWrap) {
        lbWrap.addEventListener('click', function(e) {
          e.stopPropagation();
          if (window.innerWidth <= 768) return;
          if (isZoomed) {
            exitZoom();
          } else {
            isZoomed = true;
            lightbox.classList.add('zoomed');
            var img = lbImgs[lbIdx];
            if (img) {
              img.style.transform = 'scale(' + ZOOM_SCALE + ')';
              zoomPan(img, e.clientX, e.clientY);
            }
          }
        });

        lbWrap.addEventListener('mousemove', function(e) {
          if (!isZoomed) return;
          var img = lbImgs[lbIdx];
          if (!img) return;
          zoomPan(img, e.clientX, e.clientY);
        });
      }

      /* Close button */
      var lbCloseBtn = lightbox.querySelector('.lightbox-close');
      if (lbCloseBtn) lbCloseBtn.addEventListener('click', lbClose);

      /* Click background to close (desktop) + tap dead space to close (mobile) */
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) {
          if (isZoomed) { exitZoom(); } else { lbClose(); }
        }
      });

      /* Mobile: tap anywhere outside the visible image area to close */
      if (lbWrap) {
        lbWrap.addEventListener('click', function(e) {
          if (window.innerWidth > 768) return;
          var img = lbImgs[lbIdx];
          if (!img) { lbClose(); return; }
          var r = img.getBoundingClientRect();
          var natW = img.naturalWidth || 1;
          var natH = img.naturalHeight || 1;
          var ratio = Math.min(r.width / natW, r.height / natH);
          var visW = natW * ratio;
          var visH = natH * ratio;
          var visL = r.left + (r.width - visW) / 2;
          var visT = r.top + (r.height - visH) / 2;
          var x = e.clientX, y = e.clientY;
          if (x < visL || x > visL + visW || y < visT || y > visT + visH) {
            lbClose();
          }
        });
      }

      /* Nav arrows */
      var lbPrev = lightbox.querySelector('.lightbox-prev');
      var lbNext = lightbox.querySelector('.lightbox-next');
      if (lbPrev) lbPrev.addEventListener('click', function(e) { e.stopPropagation(); lbGoTo(lbIdx - 1); });
      if (lbNext) lbNext.addEventListener('click', function(e) { e.stopPropagation(); lbGoTo(lbIdx + 1); });

      /* Keyboard nav inside lightbox */
      document.addEventListener('keydown', function(e) {
        if (!lightbox.classList.contains('open')) return;
        if (e.key === 'Escape') {
          if (isZoomed) { exitZoom(); } else { lbClose(); }
          e.preventDefault();
        }
        if (!isZoomed) {
          if (e.key === 'ArrowLeft') { lbGoTo(lbIdx - 1); e.preventDefault(); }
          if (e.key === 'ArrowRight') { lbGoTo(lbIdx + 1); e.preventDefault(); }
        }
      });

      /* Scroll wheel inside lightbox — mobile only */
      lightbox.addEventListener('wheel', function(e) {
        if (window.innerWidth > 768) return;
        e.preventDefault();
        if (isZoomed) return;
        if (e.deltaY > 0 || e.deltaX > 0) lbGoTo(lbIdx + 1);
        else lbGoTo(lbIdx - 1);
      }, { passive: false });

      /* Touch swipe inside lightbox */
      var lbTouchX = 0;
      var lbTouchIsMulti = false;
      var lbTouchMultiEnd = 0;
      lightbox.addEventListener('touchstart', function(e) {
        lbTouchIsMulti = e.touches.length > 1;
        lbTouchX = e.touches[0].clientX;
      }, { passive: true });

      lightbox.addEventListener('touchmove', function(e) {
        if (e.touches.length > 1) lbTouchIsMulti = true;
      }, { passive: true });

      lightbox.addEventListener('touchend', function(e) {
        if (lbTouchIsMulti) { lbTouchIsMulti = false; lbTouchMultiEnd = Date.now(); return; }
        if (Date.now() - lbTouchMultiEnd < 400) return;
        if (isZoomed || isPageZoomed()) return;
        var diff = e.changedTouches[0].clientX - lbTouchX;
        if (Math.abs(diff) > 40) {
          if (diff < 0) lbGoTo(lbIdx + 1);
          else lbGoTo(lbIdx - 1);
        }
      }, { passive: true });

      if (window.bindCursorHover) window.bindCursorHover();
    }
  }

  /* =============================================
     INIT
     ============================================= */
  applyCurrency();
  applyLanguage();
  bindCurrency();
  bindLanguage();
  refreshCart();
  bindSearch();
  initGallery();
  checkAlreadyInCart();

  /* =============================================
     SORT SOLD-OUT PRODUCTS — most recently updated first
     ============================================= */
  function sortSoldProducts() {
    document.querySelectorAll('.product-feed').forEach(function(feed) {
      var soldCards = Array.from(feed.querySelectorAll('.product-card.sold-out[data-updated-at]'));
      if (soldCards.length < 2) return;

      soldCards.sort(function(a, b) {
        return parseInt(b.getAttribute('data-updated-at'), 10) - parseInt(a.getAttribute('data-updated-at'), 10);
      });

      soldCards.forEach(function(card) {
        feed.appendChild(card);
      });
    });
  }
  sortSoldProducts();

  /* =============================================
     COLLECTION AVAILABILITY SYNC — REMOVED
     This previously fetched /collections/{handle}/products.json on load and
     overrode each card's availability client-side. The public products.json
     `available` flag is NOT the same authoritative value as Liquid's
     `product.available`: it resolves against the visitor's market / location /
     edge-cache context and can report in-stock variants as unavailable for
     some visitors. That made genuinely available products show "Sold Out"
     intermittently (and persistently in incognito) for a subset of visitors.

     Server-rendered Liquid `product.available` (sk-collection.liquid /
     sk-product.liquid) is authoritative and correct, so we now trust it and
     do NOT override it on the client. Do not reintroduce a products.json-based
     availability override.
     ============================================= */

  /* Expose for use by other scripts */
  window.skTranslate = skTranslate;
  window.formatPrice = formatPrice;
  window.convertAllPrices = convertAllPrices;

})();
